var map = {
	"./de/cv-play.png": "W0l0",
	"./en/cv-play.png": "Yq97",
	"./es/cv-play.png": "Aq/N",
	"./fr/cv-play.png": "/UWp",
	"./ja/cv-play.png": "LPG2",
	"./ko/cv-play.png": "zWOL",
	"./pt/cv-play.png": "6ODP",
	"./ru/cv-play.png": "0NoL",
	"./tc/cv-play.png": "yxGy",
	"./th/cv-play.png": "CT37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8hLm";